export interface IAuthTransfer {
  authApiEndPoint?: string;
  apiEndPoint?: string;
  apiVersion?: string;
  token?: string;
  version?: string;
  originDomain?: string;
  apiVersionUrl?: string;
  code?: string;
  environment: string;
  sessionId: string;
}
export class AuthTransfer {
  authApiEndPoint?: string;
  apiEndPoint?: string;
  apiVersion?: string;
  token?: string;
  version?: string;
  originDomain?: string;
  apiVersionUrl?: string;
  code?: string;
  environment: string;
    sessionId: string;
  /**
   *
   */
  constructor(values?: IAuthTransfer) {
    this.authApiEndPoint = values.authApiEndPoint;
    this.apiEndPoint = values.apiEndPoint;
    this.apiVersion = values.apiVersion;
    this.code = values.code;
    this.token = values.token;
    this.version = values.version;
    this.originDomain = values.originDomain;
    this.apiVersionUrl = `//${this.apiEndPoint}/${this.version}`;
    this.environment = values.environment || 'dev';
    this.sessionId = values.sessionId;
  }
}

export class AuthUserInfo {
  DepartmentId: number;
  DirectPhone: string;
  Email: string;
  GroupId: number;
  Id: number;
  IsActive: boolean;
  MobilePhone: string;
  Name: string;
  ShortName: string;
  SiteId: number;
  SiteName: string;
  CompanyName: string;
}
export class AuthVerified {
  UserInfo: AuthUserInfo;
  Token: string;
  RefreshToken?: string;
  OriginDomain: string;
  SessionId?: string;

  constructor(info: {
    UserInfo?: AuthUserInfo;
    Token?: string;
    OriginDomain?: string;
  }) {
    this.UserInfo = info.UserInfo;
    this.Token = info.Token;
    this.OriginDomain = info.OriginDomain;
  }
}
